import moment from 'moment'
import { I18nInfo } from '@/user/models'

/**
 * @class MonthlyCertification
 * @classdesc 월간 자격증 시험 정보
 */
class MonthlyExamModel {
  /**
   * @param {number} id - 자격증 시험 아이디
   * @param {string} name - 시험 이름
   * @param {'ESSENTIAL' | 'ASSOCIATE' | 'PROFESSIONAL'} level - 자격증 레벨
   * @param {Date} startAt - 시작 일시
   * @param {Date} finishAt - 종료 일시
   * @param {number} examTime - 시험 시간
   * @param {'DRAFT' | 'ANNOUNCED' | 'CLOSED' | 'PREPARED' | 'DROPPED' | 'IN_PROGRESS' | 'WAITING_COMPLETION' |'FINISHED'} state - 상태
   */
  constructor(data) {
    const { exam, applied } = data
    this.id = exam.id
    this.title = exam.name
    this.level = exam.level
    this.startAt = exam.startAt
    this.finishAt = exam.finishAt
    this.examTime = exam.examTime
    this.applicantCount = exam.applicantCount
    this.capacity = exam.capacity
    this.state = exam.state
    this.amount = exam.examFee
    this.method = 'ONLINE'
    this.applied = applied
  }

  get canApply() {
    return this.state === 'ANNOUNCED' && !this.applied
  }

  get isPublicVisible() {
    return this.state !== 'DROPPED'
  }

  get canApplyThisMonth() {
    if (!this.canApply) return false
    const examMonth = moment(this.startAt).format('YYYYMM')
    return examMonth === moment().format('YYYYMM')
  }

  /** ANNOUNCED/DRAFT는 그대로, 나머지는 CLOSED로 통일 */
  get displayState() {
    if (this.state === 'ANNOUNCED' || this.state === 'DRAFT') {
      return this.state
    }
    return 'CLOSED'
  }

  /** 접수 상태 분류: APPLIED | AVAILABLE | CLOSED */
  get applyState() {
    if (this.applied) return 'APPLIED'
    if (this.canApplyThisMonth) return 'AVAILABLE'
    return 'CLOSED'
  }
}

const certStateT = new I18nInfo('common.certification')
const certEnumT = new I18nInfo('common.certification.enums')

const applyKeys = { APPLIED: 'applied', AVAILABLE: 'doApply', CLOSED: 'closed' }

export const canAttend = (state) => state === 'ANNOUNCED'

export const examLabel = {
  state: (exam) => certStateT.translate(`state.${exam.displayState}`) || '',
  level: (exam) => certEnumT.translate(`level.${exam.level}`) || exam.level,
  apply: (exam) => certStateT.translate(`apply.${applyKeys[exam.applyState || 'CLOSED']}`) || '',
}

export class MonthlyExamInfo {
  constructor(data) {
    this.content = data.map((exam) => new MonthlyExamModel(exam))
  }
}
